module.exports = __webpack_public_path__ + "img/assign-to-new-user.3630475e.png";